import { ComponentFactoryResolver, Inject, Injectable, Type } from '@angular/core';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';
import { ResolverBase } from 'app/views/presentations/shared/resolverBase';

@Injectable()
export class LayoutResolver extends ResolverBase<LayoutComponent, Layout> {
    constructor(loggerFactory: LoggerFactory, componentFactoryResolver: ComponentFactoryResolver, @Inject(Layout) layouts: Layout[]) {
        super(loggerFactory.create('LayoutResolver'), componentFactoryResolver, layouts);
    }

    protected getDefaultComponent(): Type<LayoutComponent> {
        // return UnsupportedLayoutComponent;
        return undefined;
    }

    protected getDefaultComponentMetadata(): Layout {
        // return new UnsupportedLayout();
        return undefined;
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layoutResolver.ts